import { render } from "./Team_post_investment_operation_en.vue?vue&type=template&id=2ef77925&scoped=true"
import script from "./Team_post_investment_operation_en.vue?vue&type=script&lang=js"
export * from "./Team_post_investment_operation_en.vue?vue&type=script&lang=js"

import "./Team_post_investment_operation_en.vue?vue&type=style&index=0&id=2ef77925&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ef77925"

export default script